import { Row, Col, Badge } from "reactstrap";
import ProfileEdit from "../ProfileEdit/ProfileEdit";

const ProfileHeader = ({
  name,
  cuid,
  designation,
  customer_type,
  editData,
  onCustomer,
}) => {
  
  return (
    <Row className="align-items-center mb-4 pb-3 border-bottom">
      <Col xs="auto">
        <div
          className="bg-primary bg-gradient rounded-circle d-flex align-items-center justify-content-center"
          style={{ width: "50px", height: "50px" }}
        >
          <i className="bx bx-user text-white fs-5"></i>
        </div>
      </Col>
      <Col>
        <div className="d-flex justify-content-between align-items-center flex-wrap">
          <div>
            <div className="d-flex align-items-center gap-2 mb-1">
              <h5 className="mb-0 fw-bold text-dark">{name}</h5>
              {cuid && (
                <Badge
                  color="light"
                  className="text-primary border border-primary px-2 py-1"
                  pill
                  title="Customer ID"
                >
                  {cuid}
                </Badge>
              )}
            </div>
            {designation && (
              <p className="text-muted mb-0 small">{designation}</p>
            )}
            {customer_type && <Badge color="primary">{customer_type}</Badge>}
          </div>
          <ProfileEdit data={editData} onCustomer={onCustomer} />
        </div>
      </Col>
    </Row>
  )
}

export default ProfileHeader
